var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "building-handover-templates" },
    [
      _c("TMSHeader", {
        attrs: { buttons: _vm.enableButtons, title: "Handover Templates" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "template-list" }, [
        _c("table", [
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "template-name" }, [
                _vm._v(_vm._s(_vm.$t("settings.template.templateName"))),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "template-updated-by" }, [
                _vm._v(_vm._s(_vm.$t("handover.lastUpdateOnandBy"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.templateList, function (temp, index) {
              return _c("tr", { key: index }, [
                _c(
                  "td",
                  {
                    staticClass: "template-name",
                    on: {
                      click: function ($event) {
                        return _vm.gotoEditTemplatePage(temp.id)
                      },
                    },
                  },
                  [_c("a", [_vm._v(_vm._s(temp.title))])]
                ),
                _vm._v(" "),
                _c("td", { staticClass: "template-updated-by" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        temp.updator.displayName +
                          " " +
                          _vm.formatDate(temp.updatedAt)
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.templateList.length > 1 && _vm.isDeleteBtnShow
                    ? _c("i", {
                        staticClass: "operate fa-times fa",
                        on: {
                          click: function ($event) {
                            return _vm.openModal(temp, index)
                          },
                        },
                      })
                    : _vm._e(),
                ]),
              ])
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "confirm-delete-template-modal",
          staticClass: "confirm-delete-template-modal",
          attrs: { modalId: "delete-template-" + +new Date() },
        },
        [
          _c(
            "p",
            {
              staticClass: "font-bold",
              attrs: { slot: "modal-header" },
              slot: "modal-header",
            },
            [_vm._v(_vm._s(_vm.$t("settings.template.deleteHint")))]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              { staticClass: "btn--orange", on: { click: _vm.closeModal } },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn--darkblue",
                on: { click: _vm.delOneTemplate },
              },
              [_vm._v(_vm._s(_vm.$t("action.ok")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }